<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Add Employees to ' + course.course_name + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses`">
                            <i class="fa fa-graduation-cap"></i> Training Courses
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses/view/${course.id}`">
                            {{ course.course_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <i class="fa fa-plus"></i> Add Employee(s)
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-10 col-md-12">
                    <div class="card mb-3">
                        <div class="card-header">Add Employee</div>
                        <div class="card-body">

                            <div class="form-group row">
                                <label class="col-md-2 col-12 col-form-label text-sm-right text-muted">
                                    Training Course:
                                </label>
                                <div class="col-md-10 col-sm-12 pt-2">
                                    {{ course.course_name }}
                                </div>
                            </div>

                            <div class="form-group row" v-if="course.valid_days">
                                <label class="col-md-2 col-12 col-form-label text-sm-right text-muted">
                                    Course Valid For:
                                </label>
                                <div class="col-md-10 col-sm-12 pt-2">
                                    {{ course.valid_days }} Days From Completion
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.completed_at }" class="row">
                                <label class="col-md-2 col-12 col-form-label text-sm-right text-muted">
                                    Employees:
                                </label>
                                <div class="col-md-10 col-sm-12">

                                    <table class="table table-bordered table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>Employee <i class="fa fa-asterisk text-danger"></i></th>
                                                <th style="min-width: 100px;">Pending <i class="fa fa-question-circle" title="Pending Courses will remove the Completed & Expiration Date and set the course as pending completion."></i></th>
                                                <th>Date Completed</th>
                                                <th>Date Expires</th>
                                                <th class="text-center"><i class="fa fa-trash text-danger"></i></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(course, i) in empCourses">
                                                <td>
                                                    <b-form-select v-model="course.employee_id" :options="empOptions" :class="{'is-invalid': errors['courses.'+i+'.employee_id']}"></b-form-select>

                                                    <div class="text-danger" v-if="errors['courses.'+i+'.employee_id']">
                                                        <span v-for="error in errors['courses.'+i+'.employee_id']">{{ error }}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <b-form-checkbox v-model="course.is_pending" :value="true" :unchecked-value="false" plain v-on:change="setPending(i)"></b-form-checkbox>
                                                </td>
                                                <td>
                                                    <date-picker v-model="course.completed_at" :config="{format: 'MM/DD/YYYY', useCurrent: false}" :class="{ 'is-invalid': errors['courses.'+i+'.completed_at'] }" placeholder="Course Date" @dp-change="completedChanged($data, i)"></date-picker>

                                                    <div class="text-danger"  v-if="errors['courses.'+i+'.completed_at']">
                                                        <span v-for="error in errors['courses.'+i+'.completed_at']">{{ error }}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <date-picker v-model="course.expires_at" :config="{format: 'MM/DD/YYYY', useCurrent: false}" :class="{ 'is-invalid': errors['courses.'+i+'.expires_at'] }" placeholder="Expire Date"></date-picker>

                                                    <div class="text-danger"  v-if="errors['courses.'+i+'.expires_at']">
                                                        <span v-for="error in errors['courses.'+i+'.expires_at']">{{ error }}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-link" v-on:click="deleteEmployee(i)">
                                                        <i class="fa fa-trash text-danger"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="4" class="text-center">
                                                    <button class="btn btn-link" v-on:click="addEmployee()"><i class="fa fa-plus-circle text-success"></i> Add Employee</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveEmployees()" :disabled="saving">
                Add Employees
            </button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                employees: [],
                course: {},
                empCourses: [],
                errors: {},
            }
        },

        computed: {
            empOptions(){
                //Setup
                var options = [{value: null, text: '-- Select an Active Employee --'}];

                //Loop and Build
                for(var i = 0; i < this.employees.length; i++)
                {
                    options.push({value: this.employees[i].EmployeeId, text: (this.employees[i].LastName + ', ' + this.employees[i].FirstName + ' - ' + this.employees[i].EmployeeNumber)});
                }

                //Send it
                return options;
            },
        },

        watch: {

        },

        methods: {

            addEmployee(){
                //Create Some Defaults
                var now = new Date();
                var expiration = null;

                //Check to see if the course has an expiration setting
                if(this.course.valid_days)
                {
                    //Setup the exipration
                    var expire_date = new Date(now);

                    //Set the Date
                    expire_date.setDate(now.getDate() + this.course.valid_days);

                    //Format it
                    expiration = (expire_date.getMonth() + 1)+'/'+expire_date.getDate()+'/'+expire_date.getFullYear();
                }

                //Setup
                this.empCourses.push({
                    employee_id: null,
                    completed_at: (now.getMonth() + 1)+'/'+now.getDate()+'/'+now.getFullYear(),
                    expires_at: expiration,
                });
            },

            completedChanged ( data, i ) {
                //Set it
                this.setExpiration(i);
            },

            setPending(i){
                //Get the course
                var empCourse = this.empCourses[i];

                //Clear Both
                empCourse.completed_at = null;
                empCourse.expires_at = null;
            },

            setExpiration(i){
                //Get the empCourse
                var empCourse = this.empCourses[i];

                //Checks
                if(!empCourse.completed_at)
                {
                    //Make sure expiration is empty?
                    empCourse.expires_at = null;

                    //Stop Here
                    return;
                }

                //Check
                if(!this.course.valid_days)
                {
                    return;
                }

                //Set it
                var completed_date = new Date(empCourse.completed_at)
                var expire_date = new Date(empCourse.completed_at);

                //Set the Date
                expire_date.setDate(completed_date.getDate() + this.course.valid_days);

                //Format and set
                empCourse.expires_at = (expire_date.getMonth() + 1)+'/'+expire_date.getDate()+'/'+expire_date.getFullYear();
            },

            deleteEmployee(i){
                //SPlice
                this.empCourses.splice(i, 1);
            },

            getData() {
                //Get the data
                this.$http
                    .get('/training-courses/course/'+this.id+ '/employees')
                    .then(response => {
                        //Set all the data
                        this.employees = response.data.employees;
                        this.course = response.data.course;

                        //Add
                        this.addEmployee();
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            saveEmployees() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('/training-courses/course/'+this.id+ '/employees', {courses: this.empCourses})
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Training Courses Added');

                    //Check it
                    this.$router.push('/training-courses/view/' + this.id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            useSuggestedExpiration(){
                //Set it
                this.empCourse.expires_at = this.suggestedExpirationDate;

                //Force update
                this.$forceUpdate();
            },
        },

        mounted() {
            //Get the Training Course
            this.getData();
        }
    }
</script>
